import { isParagraphEntry, Queries } from '@aline/common';
import { Editor } from 'slate';
import type { Location } from 'slate';
import type { SelectedAlineReference } from 'src/editor';

/**
 * Returns the location of the reference in the editor.
 */
export function getCMLocationFromReference(
  editor: Editor,
  aiReference: SelectedAlineReference
): Location {
  const cMParagraphEntry = Editor.node(editor, aiReference.locationPath);
  if (!isParagraphEntry(cMParagraphEntry) || !aiReference.referenceText)
    return aiReference.locationPath;

  const searchHits = Queries.getCMSearchHits({
    cMParagraphEntry,
    matchAccents: false,
    matchCase: false,
    search: aiReference.referenceText,
  });
  return searchHits.at(0) ?? aiReference.locationPath;
}
